const findingsData = [
  "Normal Sinus Rhythm",
  "Sinus Rhythm",
  "Sinus Bradycardia",
  "Sinus Tachycardia",
  "Sinus Arrhythmia",
  "Supraventricular Tachycardia",
  "Atrial Fibrillation",
  "Atrial Flutter",
  "J Point Elevation",
  "ST Depression",
  "T Wave Inversion",
  "ST Depression and T-wave Inversion",
  "R/S > 1 in leads V1 & V2",
  "Biphasic T waves",
  "Possible Ischemia",
  "Ventricular Bigeminy",
  "Ventricular Trigeminy",
  "Paced Rhythm",
  "First Degree AV Block",
  "Mobitz Type 1 AV Block",
  "Mobitz Type II AV Block",
  "Third Degree Complete Block",
  "Ventricular Tachycardia",
  "PAC",
  "VPC",
  "Junctional Rhythms",
  "Ventricular Couplets",
  "Anterolateral MI",
  "Anteroseptal MI",
  "Antero - Apical MI",
  "Anterior Wall MI",
  "Inferior MI",
  "Infero Lateral MI",
  "Infero Septal MI",
  "Lateral Wall MI",
  "LBBB",
  "RBBB",
  "Ischemia",
  "RVH",
  "WPW Syndrome",
  "Baseline Wandering Artifact",
  "AC Interference Artifact",
  "Muscle Tremor Artifact",
  // "ST- depression and T-wave inversion",
  // "Lead placement incorrect",
  // "Consult to the cardiologist"
];

export default findingsData;
